import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated, getStoredAuthRole, getLoginRoute } from "../utils/auth";

const ProtectedRoute = ({ children, allowedRoles = [], redirectTo = null, requireAuth = true }) => {
  const location = useLocation();
  const [isReady, setIsReady] = useState(false);
  const authenticated = isAuthenticated();
  const role = getStoredAuthRole();

  useEffect(() => {
    const timeout = window.setTimeout(() => setIsReady(true), 50);
    return () => window.clearTimeout(timeout);
  }, []);

  if (!isReady) {
    return <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5] text-lg text-teal-700">Checking access…</div>;
  }

  if (!requireAuth) {
    return children;
  }

  if (!authenticated) {
    return <Navigate to={redirectTo || getLoginRoute(role)} replace state={{ from: location }} />;
  }

  if (allowedRoles.length && !allowedRoles.includes(role)) {
    return <Navigate to={redirectTo || "/"} replace />;
  }

  return children;
};

export default ProtectedRoute;
